
var mobile_app = mobile_app || {};
mobile_app = {
	body:$(document.body),
    layout: function () {

        var myPlayer = false;
		if($('#my-video').length && !myPlayer){
			myPlayer = document.getElementById('my-video');//videojs('my-video', {controls: true, autoplay: 'play', preload: 'auto'});
		}

        $('.js-show-popup-image').on('click', function (e) {
            mobile_app.body.addClass('active-popup-image popup-overflow-hidden');
        });

        $('.js-show-popup-video').on('click', function (e) {
            mobile_app.body.addClass('active-popup-video popup-overflow-hidden');
        });

        $('.js-show-popup-map').on('click', function (e) {
            mobile_app.body.addClass('active-popup-map popup-overflow-hidden');
        });

        $('.js-close-popup-123').on('click', function () {
            mobile_app.body.removeClass('active-popup-image');
            mobile_app.body.removeClass('active-popup-video');
            mobile_app.body.removeClass('active-popup-map');
            mobile_app.body.removeClass('popup-overflow-hidden');
            if(myPlayer){
                myPlayer.pause();
            }

			if($('.js-video-youtube').length){
				$('.js-video-youtube').each(function(){
					$(this)[index].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
					$(this)[index].contentWindow.postMessage({type: 'pause', 'x-tiktok-player': true}, '*');
				});
			}
        });

        $('.js-hamburger-button, .panel-backdrop') .on('click', function () {
            mobile_app.body.toggleClass('active-menu-mobile');
        });

        $('.js-show-filter-mobile, .filter-mobile-overlay') .on('click', function () {
            mobile_app.body.toggleClass('active-filter-mobile');
        });

        $('.js-close-photos-mobile-fullscreen').on('click', function () {
			$('.photos-mobile-fullscreen-wrapper').css('display', 'none');
        });

        $('.js-jump-to-top').on('click', function (e) {
            $('html,body').animate({ scrollTop: 0 }, 'fast');
        })
        $('.js-nav-mobile-expand').on('click', function (e) {
            $( this ).parent().toggleClass('active');
        })

        $('.js-tab-accordion-heading').on('click', function(e){
            var tab_index = $(this).attr('data-tab-accordion');
            $('#js-tab-accordion-item-' + tab_index).toggleClass('active');
        });
	},
	init: function(){
		this.layout();
	}
};

jQuery(function($) {
	mobile_app.init();
});
